import React from 'react'

import { ConditionalCellRenderer } from '../cell-renderers'
import { useDynamicViewContext } from '../context'
import { getDynamicViewFieldDefinition } from '../utils'
import { PivotColumn, PivotRow } from './PivotTable'
import { PIVOT_LABEL_COLUMN_WIDTH, PivotBodyRow, PivotDataCell, PivotRowLabelCell } from './PivotTable.styles'

interface Props {
  row: PivotRow
  pivotColumns: PivotColumn[]
  hoveredColumnId: string | undefined
  setHoveredColumnId: (value: string | undefined) => void
}

export function PivotTableRow({ row, pivotColumns, hoveredColumnId, setHoveredColumnId }: Props) {
  const { styleMode, onRowClick, viewModel, baseMetadata, pinned } = useDynamicViewContext()

  const mode = styleMode ?? 'Default'

  return (
    <PivotBodyRow>
      <PivotRowLabelCell
        $first={true}
        $visible={true}
        scope="row"
        size="small"
        styleMode={mode}
        $width={PIVOT_LABEL_COLUMN_WIDTH}
        $pinned={pinned}
      >
        {row.label}
      </PivotRowLabelCell>

      {pivotColumns.map((column) => {
        const cell = row.values[column.id]

        return (
          <PivotDataCell
            $visible={true}
            key={column.id}
            scope="row"
            size="small"
            styleMode={mode}
            $highlighted={hoveredColumnId === column.id}
            $clickable={!!onRowClick}
            onMouseEnter={() => setHoveredColumnId(column.id)}
            onMouseLeave={() => setHoveredColumnId(undefined)}
            onClick={() => onRowClick?.(column.entity)}
          >
            <ConditionalCellRenderer
              value={cell.value}
              col={cell.column}
              field={getDynamicViewFieldDefinition(viewModel, baseMetadata, row.fieldName).fieldDefinitionType}
            />
          </PivotDataCell>
        )
      })}
    </PivotBodyRow>
  )
}
